/* SU Recs v2 - the smart picks live INSIDE the existing "You may also like" row.
   Reads the map inlined from the su_recs.map shop metafield, then on every cart
   change: ranks the row so the best data-backed picks for THIS cart float to the
   front with a one-line pitch, injects any missing pick as a native-looking card,
   and leaves everything else in original order. Existing drawer code handles all
   adds, tracking and in-cart hiding. Fails silently in every path. */
(function () {
  'use strict';

  var MAX_RECS = 3;

  /* ---------- map ---------- */
  var MAP = null;
  try {
    var node = document.querySelector('script[data-su-recs-map]');
    if (node) MAP = JSON.parse(node.textContent || 'null');
  } catch (e) { MAP = null; }
  if (!MAP || !MAP.products || !MAP.sku_to_key || !MAP.catalog) return;

  function resolve(ref) {
    var c = ref && MAP.catalog[ref.sku];
    if (!c) return null;
    return { sku: ref.sku, pitch: ref.pitch, title: c.t, handle: c.h, price: c.p, image: c.i };
  }

  /* ---------- segment: first vs repeat ---------- */
  function segment() {
    try { return localStorage.getItem('su_ordered') === '1' ? 'repeat' : 'first'; } catch (e) { return 'first'; }
  }
  document.addEventListener('click', function (ev) {
    try {
      if (ev.target && ev.target.closest && ev.target.closest('[data-su-checkout]')) {
        localStorage.setItem('su_ordered', '1');
      }
    } catch (e) {}
  }, true);

  /* ---------- pick up to 3 recs for the current cart ---------- */
  function pickRecs(cart) {
    var items = (cart && cart.items) || [];
    if (!items.length) return [];
    var inCart = {};
    items.forEach(function (it) { if (it.handle) inCart[it.handle] = true; });
    var seg = segment(), seen = {}, picked = [];
    for (var i = 0; i < items.length && picked.length < MAX_RECS; i++) {
      var key = MAP.sku_to_key[String(items[i].sku || '')];
      if (!key && MAP.handle_to_key) key = MAP.handle_to_key[items[i].handle];
      var entry = key && MAP.products[key];
      if (!entry) continue;
      var recs = entry[seg] || entry.first || [];
      for (var j = 0; j < recs.length && picked.length < MAX_RECS; j++) {
        var r = resolve(recs[j]);
        if (!r || inCart[r.handle] || seen[r.handle]) continue;
        seen[r.handle] = true;
        picked.push(r);
      }
    }
    return picked;
  }

  /* ---------- row helpers ---------- */
  function cardHandle(card) {
    try {
      var a = card.querySelector('a[href*="/products/"]');
      if (!a) return '';
      var m = a.getAttribute('href').match(/\/products\/([^\/?#]+)/);
      return m ? m[1] : '';
    } catch (e) { return ''; }
  }
  function cardSoldOut(card) {
    var b = card.querySelector('[data-su-upsell-add]');
    return !b || b.disabled;
  }
  function money(cents) {
    try {
      var inst = window.SUCartDrawerInstance;
      if (inst && typeof inst.money === 'function') return inst.money(Number(cents) || 0);
    } catch (e) {}
    return '\u20B9' + Math.round((Number(cents) || 0) / 100).toLocaleString('en-IN');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function addLabel(row) {
    var b = row.querySelector('[data-su-upsell-add]:not([disabled])');
    return (b && b.textContent.trim()) || 'ADD +';
  }

  /* one cached product fetch per missing pick, to build a native card */
  var pcache = {};
  function getProduct(handle) {
    var inst = window.SUCartDrawerInstance;
    if (inst && typeof inst.getProduct === 'function') return Promise.resolve(inst.getProduct(handle));
    if (pcache[handle]) return pcache[handle];
    pcache[handle] = fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return pcache[handle];
  }

  function buildCard(rec, product, label) {
    var v = null;
    (product.variants || []).forEach(function (x) {
      if (!v && String(x.sku) === rec.sku && x.available !== false) v = x;
    });
    if (!v) (product.variants || []).forEach(function (x) { if (!v && x.available !== false) v = x; });
    if (!v) return null;                                  /* fully sold out: never display */
    var img = rec.image ? rec.image + (rec.image.indexOf('?') > -1 ? '&' : '?') + 'width=240' : '';
    var card = document.createElement('article');
    card.className = 'su-cart__upsell';
    card.setAttribute('data-su-upsell-card', '');
    card.setAttribute('data-su-rec', '1');
    card.setAttribute('data-variant-id', v.id);
    card.innerHTML = '' +
      '<a class="su-cart__upsell-img" href="/products/' + esc(rec.handle) + '">' +
        (img ? '<img src="' + esc(img) + '" alt="' + esc(rec.title) + '" width="240" height="240" loading="lazy">' : '') +
      '</a>' +
      '<h5><a href="/products/' + esc(rec.handle) + '">' + esc(rec.title) + '</a></h5>' +
      (v.title && v.title !== 'Default Title' ? '<div class="su-cart__upsell-variant">' + esc(v.title) + '</div>' : '') +
      '<div class="su-cart__upsell-price">' +
        '<span>' + money(v.price) + '</span>' +
        (v.compare_at_price && v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '') +
      '</div>' +
      '<button type="button" class="su-cart__upsell-add" data-su-upsell-add data-variant-id="' + v.id + '">' + esc(label) + '</button>';
    return card;
  }

  /* ---------- rank the row ---------- */
  var originalOrder = null;    /* the Liquid-rendered cards, in server order */
  var updateToken = 0;

  function update(cart, row) {
    try {
      if (originalOrder === null) {
        originalOrder = Array.prototype.slice.call(row.querySelectorAll('[data-su-upsell-card]:not([data-su-rec])'));
      }
      var token = ++updateToken;
      var picks = pickRecs(cart);

      /* index existing cards by handle (Liquid + previously injected) */
      var byHandle = {};
      Array.prototype.forEach.call(row.querySelectorAll('[data-su-upsell-card]'), function (c) {
        var h = cardHandle(c);
        if (h && !byHandle[h]) byHandle[h] = c;
      });

      /* drop injected cards that are no longer picked */
      Array.prototype.forEach.call(row.querySelectorAll('[data-su-rec]'), function (c) {
        var h = cardHandle(c);
        if (!picks.some(function (p) { return p.handle === h; })) c.remove();
      });

      var front = [];
      var missing = [];
      picks.forEach(function (p) {
        var c = byHandle[p.handle];
        if (c && !cardSoldOut(c)) front.push({ card: c, pick: p });
        else if (!c) missing.push(p);
        /* sold out in row: leave it in the tail, never promote */
      });

      /* deterministic full reorder: picks first, then everything else in
         original server order. One pass, immune to any prior partial state. */
      var used = {};
      front.forEach(function (f) { used[cardHandle(f.card)] = true; });
      var desired = front.map(function (f) { return f.card; });
      originalOrder.forEach(function (c) {
        if (c.isConnected && !used[cardHandle(c)]) desired.push(c);
      });
      Array.prototype.forEach.call(row.querySelectorAll('[data-su-rec]'), function (c) {
        if (desired.indexOf(c) === -1 && c.isConnected) desired.push(c);
      });
      desired.forEach(function (c) { row.appendChild(c); });
      row.scrollLeft = 0;                                  /* picks visible without scrolling */

      /* build any picks not present in the row (async, native markup) */
      var label = addLabel(row);
      missing.forEach(function (p, idx) {
        getProduct(p.handle).then(function (product) {
          if (token !== updateToken || !product) return;
          if (row.querySelector('[data-su-rec][data-variant-id]') && byHandle[p.handle]) return;
          var card = buildCard(p, product, label);
          if (!card) return;
          /* insert at its pick position among the promoted cards */
          var pos = picks.indexOf(p);
          var anchor = row.children[Math.min(pos, row.children.length)] || null;
          row.insertBefore(card, anchor);
          row.scrollLeft = 0;
        }).catch(function () {});
      });
    } catch (e) { /* never break the drawer: original order remains */ }
  }

  /* ---------- wire up ---------- */
  function start() {
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      var inst = window.SUCartDrawerInstance;
      var root = document.querySelector('[data-su-cart]');
      var row = root && root.querySelector('.su-cart__upsells-row');
      if (inst && row) {
        clearInterval(timer);
        if (inst.cart) update(inst.cart, row);
        var itemsEl = root.querySelector('[data-su-items]');
        if (itemsEl) {
          var deb = null;
          new MutationObserver(function () {
            clearTimeout(deb);
            deb = setTimeout(function () {
              var i2 = window.SUCartDrawerInstance;
              if (i2 && i2.cart) update(i2.cart, row);
            }, 150);
          }).observe(itemsEl, { childList: true, subtree: false });
        }
      } else if (tries > 100) {
        clearInterval(timer);
      }
    }, 100);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();